import React, { JSX, PropsWithChildren } from 'react'
import './index.scss'

interface WizardStepHeadingProps {
    heading: string | JSX.Element
    title?: string
}

const WizardStepHeading = ({ heading, children, title }: PropsWithChildren<WizardStepHeadingProps>) => {
    const childArray = React.Children.toArray(children)

    return (
        <div className="wizard-step-heading">
            <h6>{heading}</h6>
            {childArray.map((child, index) => (
                <p key={index}>{child}</p>
            ))}
            {title && <h1>{title}</h1>}
        </div>
    )
}

export default WizardStepHeading
